import { Directive, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { WorkCenterTypeService } from '../work-center-type.service'

@Directive({
  selector: '[appWorkCenterTypeSelect]',
})
export class WorkCenterTypeSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const typeService = inject(WorkCenterTypeService)
    this.select.displayProperty = 'name'
    this.select.placeholder = 'context.type'
    this.select.dataSource = typeService
    this.select.sorts = [new Sort('id', 'asc')]
  }
}
